
import * as _ref_Li9SZXNvdXJjZUJ1bmRsZUludGVyb3AubWpz_ from './ResourceBundleInterop.mjs';
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './lobbyApp.uninstantiated.mjs';


const exports = (await instantiate({
    './ResourceBundleInterop.mjs': _ref_Li9SZXNvdXJjZUJ1bmRsZUludGVyb3AubWpz_,
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
memory,
_initialize
} = exports


